import { Assets } from 'pixi.js';
import type { App } from '../app/App';
import type { BlockerIntroType } from '../game/blockers/constants';
import { BlockerIntroductionPopup } from '../game/blockers/BlockerIntroductionPopup';
import { BLOCKER_INTRO_CONFIG_MAP } from '../game/blockers/constants';
import { LoadingView } from '../views/LoadingView';

export async function openBlockerIntroductionPopup(
  app: App,
  blockerIntroType: BlockerIntroType,
): Promise<void> {
  const config = BLOCKER_INTRO_CONFIG_MAP[blockerIntroType];
  
  if (!config) {
    console.warn(`No definition found for blocker type: ${blockerIntroType}`);
    return Promise.resolve();
  }
  
  void LoadingView.getInstance().show();
  await Assets.load(config.icon);
  void LoadingView.getInstance().hide();

  const popup = new BlockerIntroductionPopup(config);

  void app.controller.popups.addPopup({
    popupInstance: popup,
    settings: { hideRays: true, overlay: false },
  });

  let shouldShowTutorial = true;
  return new Promise<void>((resolve) => {
    popup.onButtonClicked.connect(async () => {
      if (config.tutorialData && shouldShowTutorial) {
        void popup.showTutorial(config.tutorialData);
        shouldShowTutorial = false;
      } else {
        await app.controller.popups.closeActivePopup();
        resolve();
      }
    });
  });
}